var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAchSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 21 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.263 14.67h1.18L5.035 8.013H3.724L1.31 14.67h1.188l.466-1.341h2.834l.466 1.34Zm-2.938-2.368L4.38 9.297l1.056 3.005H3.325Zm7.532 2.491c1.227 0 2.31-.627 2.862-1.597l-.95-.542c-.343.656-1.075 1.074-1.912 1.074-1.436 0-2.387-1.017-2.387-2.386 0-1.37.951-2.387 2.387-2.387.837 0 1.56.418 1.911 1.074l.951-.551c-.56-.97-1.645-1.588-2.862-1.588-2.026 0-3.48 1.521-3.48 3.452 0 1.93 1.454 3.451 3.48 3.451Zm7.52-6.78v2.73h-2.854v-2.73H14.43v6.657h1.093v-2.882h2.853v2.882h1.094V8.013h-1.094Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAchSmall);
export default __webpack_public_path__ + "static/media/ach-small.c22747107ba04d85ac43b2e349294a78.svg";
export { ForwardRef as ReactComponent };